const t10Faq = {

    ui: {},

	init: function() {
		this.bindUI();
		
        this.initSlider();
	},

    bindUI: function() {
		this.ui.$slider = $('.js-faqFilter-slider');
	},

    initSlider: function() {
		this.ui.$slider.slick({
            centerMode: false,
            dots: false,
			infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            nextArrow: '<button class="button-chevron slick-next faq__filterContainer__button" type="button"><svg class="icon icon-caret"><use xlink:href="#icon-caret"/></svg></button>',
            prevArrow: false,
            mobileFirst: true,

            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
            ],
        })
	},

    
    // ui: {},

    // max_post_count: 0,

    // init: function () {
    //     this.bindUI()
    //     this.bindEvents()
    // },

    // bindUI: function bindUI() {
    //     this.ui.$loadMore = $(".js-pushJobOffer-loadMore");

    //     this.ui.$ajaxLoader = $(".js-ajaxLoader");

    //     this.ui.$jobOffer_list = $(".js-pushJobOffer-list");
    //     this.max_post_count = parseInt(this.ui.$jobOffer_list.attr('data-max-post-count'));
    // },

    // bindEvents: function bindEvents() {
    //     this.ui.$loadMore.on('click', this.loadMore.bind(this));
    // },

    // loadMore: function (e) {
    //     let $this = $(e.currentTarget);
    //     let $container = $this.closest('.js-pushJobOffer');
    //     let $ajaxLoader = $container.find('.js-ajaxLoader');
    //     let $jobOffer_list = $container.find('.js-pushJobOffer-list');
    //     let total_job_offer_item = $jobOffer_list.find('.js-pushJobOffer-list-item').length;

    //     if (!$ajaxLoader.hasClass('loaderAnimation--is-hidden')) {
    //         return false;
    //     }

    //     $ajaxLoader.removeClass('loaderAnimation--is-hidden');

    //     $.ajax({
    //         url: wordpress_vars.ajax_url,
    //         type: 'POST',
    //         data: {
    //             'action': 'load_more_job_offer',
    //             'total_job_offer_item': total_job_offer_item
    //         },
    //         success: (response) => {
    //             let $result = $( response );
    //             $ajaxLoader.addClass('loaderAnimation--is-hidden');
    //             $jobOffer_list.append($result);

    //             let current_post_count = $jobOffer_list.find('.js-pushJobOffer-list-item').length;
    //             if (current_post_count >= this.max_post_count) {
    //                 $this.hide();
    //             }
    //         },
    //         error: (response) => {
    //             console.log(response);
    //             $ajaxLoader.addClass('loaderAnimation--is-hidden');
    //         },
    //     })
    // },
}

module.exports = t10Faq
